<template>
  <div class="my-3">
    <CFormInput
      @change="ChangeNumber"
      oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
    />
  </div>
</template>
<script>
export default {
  setup() {
    const ChangeNumber = ($event) => {
    if ($event?.target?.value) {
      $event.target.value = `${Number($event.target.value)}`
    }
  };
    return {
      ChangeNumber
    }
  }
}
</script>